<template>

  <span>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-tabs :value="active_step" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none"
                 id="profile-tabs" :key="isSmallerScreen">
           <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Service categories' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <other-supplier-category-manage/>
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Service/Product type' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <other-supplier-services/>
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-archive" :label="!isSmallerScreen ? 'Other service orders' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <other-supplier-orders-list/>
<!--              todo: other supplier order-->
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </span>
</template>

<script>

  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  const CustomerRepository = RepositoryFactory.get('customer');
  import OtherSupplierServices
    from "@/views/pages/supplier-manage/other-suppliers/sundry-supplier-tabs/OtherSupplierServices";
  import OtherSupplierOrdersList
    from "@/views/pages/supplier-manage/other-suppliers/sundry-supplier-tabs/service-orders/OtherSupplierOrdersList";
  import OtherSupplierCategoryManage
    from "@/views/pages/supplier-manage/other-supplier-category/OtherSupplierCategoryManage";

  export default {
    name: 'OtherServicesTabView',
    components: {
      OtherSupplierServices,
      OtherSupplierOrdersList,
      OtherSupplierCategoryManage,
    },
    data() {
      return {
        active_step: this.$route.query.step ? this.$route.query.step : '0'
      }
    },
    computed: {
      isSmallerScreen() {
        return this.$store.state.windowWidth < 768
      }
    },
    methods: {}
  }
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
